(function () {
  if (window.__vmSupplierRevealInit) return;
  window.__vmSupplierRevealInit = true;

  var SUPPLIER_FORM_ID = '289b9142-211e-433d-bc18-284386724b18';

  function getScrollOffset() {
    var padding = 16;
    var headerBottom = 0;
    var headerContainer = document.querySelector('.header-group-container');

    if (headerContainer) {
      var rect = headerContainer.getBoundingClientRect();
      headerBottom = rect.top <= 0 ? rect.bottom : rect.height;
    }

    if (window.innerWidth <= 1024) {
      var mobileSection = document.querySelector('.section-header-mobile');
      if (mobileSection && window.getComputedStyle(mobileSection).display !== 'none') {
        var mobileRect = mobileSection.getBoundingClientRect();
        var mobileHeight = mobileRect.top <= 0 ? mobileRect.bottom : mobileRect.height;
        headerBottom = Math.max(headerBottom, mobileHeight);
      }
    }

    if (headerBottom > 0) return headerBottom + padding;

    var stickyHeader =
      window.innerWidth > 1024
        ? document.querySelector('sticky-header')
        : document.querySelector('sticky-header-mobile');

    if (stickyHeader) {
      return stickyHeader.getBoundingClientRect().height + padding;
    }

    var cssHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    if (!isNaN(cssHeight) && cssHeight > 0) return cssHeight + padding;

    return 120 + padding;
  }

  function getSupplierFormScrollTarget() {
    var formMarker = document.querySelector('[data-form-id="' + SUPPLIER_FORM_ID + '"]');
    if (!formMarker) return null;

    return (
      formMarker.closest('.shopify-section') ||
      formMarker.closest('.shopify-app-block') ||
      formMarker
    );
  }

  function scrollToSupplierForm() {
    var target = getSupplierFormScrollTarget();
    if (!target) return false;

    var top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function isSupplierApplyLink(link) {
    if (!link || !link.closest('.vm-supplier-page')) return false;
    if (link.classList.contains('vm-supplier-apply-link')) return true;

    var href = link.getAttribute('href') || '';
    return href === '#apply' || href.indexOf('#apply') === href.length - 6;
  }

  function initSupplierApplyLinks() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!isSupplierApplyLink(link)) return;

      event.preventDefault();

      if (scrollToSupplierForm()) return;

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (scrollToSupplierForm() || attempts >= 20) {
          clearInterval(timer);
        }
      }, 150);
    });
  }

  function initSupplierReveal() {
    var els = document.querySelectorAll('.vm-supplier-page [data-vm-reveal]');
    if (!els.length) return;

    var reveal = function (el) {
      el.classList.add('is-visible');
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      els.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      els.forEach(reveal);
    }

    setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains('is-visible')) {
          reveal(el);
        }
      });
    }, 1600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSupplierReveal();
      initSupplierApplyLinks();
    });
  } else {
    initSupplierReveal();
    initSupplierApplyLinks();
  }
})();
